'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _isEmpty2 = require('lodash/isEmpty');

var _isEmpty3 = _interopRequireDefault(_isEmpty2);

var _desc, _value, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

var _ProjectStatus = require('components/Project/ProjectStatus/ProjectStatus');

var _ProjectStatus2 = _interopRequireDefault(_ProjectStatus);

var _ValueLine = require('components/ValueLine/ValueLine');

var _ValueLine2 = _interopRequireDefault(_ValueLine);

var _StatisticsInfoLine = require('components/Statistics/StatisticsInfoLine/StatisticsInfoLine');

var _StatisticsInfoLine2 = _interopRequireDefault(_StatisticsInfoLine);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var styles = require('./StatisticsSelectedProjectInfo.scss');

var StatisticsSelectedProjectInfo = (_class = (_temp = _class2 = function (_PureComponent) {
  (0, _inherits3.default)(StatisticsSelectedProjectInfo, _PureComponent);

  function StatisticsSelectedProjectInfo() {
    (0, _classCallCheck3.default)(this, StatisticsSelectedProjectInfo);
    return (0, _possibleConstructorReturn3.default)(this, (StatisticsSelectedProjectInfo.__proto__ || (0, _getPrototypeOf2.default)(StatisticsSelectedProjectInfo)).apply(this, arguments));
  }

  (0, _createClass3.default)(StatisticsSelectedProjectInfo, [{
    key: 'onChange',
    value: function onChange() {
      this.context.push('/statistics/project');
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          project = _props.project,
          loading = _props.loading,
          showChangeButton = _props.showChangeButton;
      var t = this.context.t;


      if ((0, _isEmpty3.default)(project) || loading) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        { className: (0, _bind2.default)(styles.info, className) },
        showChangeButton && _react2.default.createElement(_StatisticsInfoLine2.default, {
          title: t('Project') + ' "' + project.fullTitle + '"',
          onChange: this.onChange
        }),
        !showChangeButton && _react2.default.createElement(_ValueLine2.default, { title: t('Project'), value: project.fullTitle, titleClass: styles.title }),
        _react2.default.createElement(_ValueLine2.default, { title: t('Project ID'), value: project.projectId, titleClass: styles.title }),
        _react2.default.createElement(_ValueLine2.default, { title: t('Status'), value: _react2.default.createElement(_ProjectStatus2.default, { status: project.status }), titleClass: styles.title }),
        _react2.default.createElement(_ValueLine2.default, { title: t('Manager'), value: project.owName, titleClass: styles.title })
      );
    }
  }]);
  return StatisticsSelectedProjectInfo;
}(_react.PureComponent), _class2.propTypes = {
  className: _propTypes2.default.string,
  loading: _propTypes2.default.bool,
  project: _propTypes2.default.object,
  showChangeButton: _propTypes2.default.bool
}, _class2.contextTypes = {
  push: _propTypes2.default.func,
  t: _propTypes2.default.func
}, _class2.defaultProps = {
  project: {},
  showChangeButton: false
}, _temp), (_applyDecoratedDescriptor(_class.prototype, 'onChange', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'onChange'), _class.prototype)), _class);
exports.default = StatisticsSelectedProjectInfo;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Statistics/StatisticsSelectedProjectInfo/StatisticsSelectedProjectInfo.js
// module id = 851
// module chunks = 1